module.exports = __webpack_public_path__ + "55f06dc495fd4371e1a411d5f0e744b2.svg";